<template>
  <tr
    :class="[
      `${index === 0 ? 'lead font-weight-bold text-white top-winner' : 'font-weight-bold consolation-winner'} text-nowrap`, 
      classEffects
    ]" 
    :key="item.id"
  >
    <td v-if="index === 0" class="pr-0 text-center">
      <img src="img/trophy-1.png" height="40px">
    </td>
    <td v-else class="pr-0 text-center">
      <img src="img/trophy-default.png" height="40px">
    </td>
    <th 
      scope="row" 
      :class="`text-center ${index === 0 ? 'text-white' : ''}`" 
      id="rank"
    >
      {{ index+1 }}
    </th>
    <td scope="row" class="text-uppercase">{{ item.name }}</td>
    <td scope="row" class="text-uppercase">{{ item.company }}</td>
    <td scope="row">{{ item.minutes }}mins/{{ item.seconds }}secs</td>
  </tr>
</template>

<script>
export default {
  name: 'LeaderBoardItem',
  props: [ 'item', 'index' ],
  data() {
    return {
      classEffects: {
        'bg-secondary': false,
        'text-white': false
      }
    }
  },
  watch: {
    item(val) {
      this.addEffects();
    }
  },
  methods: {
    addEffects() {
      this.classEffects = {
        'bg-secondary': true,
        'text-white': true
      }

      setTimeout(() => {
        this.classEffects = {
          'bg-secondary': false,
          'text-white': false
        };
      }, 5000);
    }
  }
}
</script>

<style scoped>
.th, #rank {
  color: #3396D9;
  font-size: 25px;
}

.consolation-winner {
  font-size: 22px;
}

.top-winner {
  background-color: #006BCC;
  font-size: 32px!important;
}
</style>